import actionTypes from './actionTypes'

export const requestInitLoad = ()  => ({
    type: actionTypes.INIT_LOAD_REQUEST
})


export const requestAuthLoginSession = (username, password) => ({
    type: actionTypes.AUTH_FLOW_LOGIN_REQUEST_SESSION,
    payload: {
        username: username,
        password: password
    }
})

export const requestAuthLoginBypass = (username, password) => ({
    type: actionTypes.AUTH_FLOW_LOGIN_REQUEST_BYPASS,
    payload: {
        username: username,
        password: password
    }
})

export const requestAuthLoginForceBypass = () => ({
    type: actionTypes.AUTH_FLOW_LOGIN_REQUEST_FORCE_BYPASS
})


export const requestAuthLoginForceSession = () => ({
    type: actionTypes.AUTH_FLOW_LOGIN_REQUEST_FORCE_SESSION
})


export const requestAuthLogoutWP = () => ({
    type: actionTypes.AUTH_FLOW_LOGOUT_REQUEST_WP
})

export const clearAuthData = () => ({
    type: actionTypes.AUTH_CLEAR_DATA
})


export const requestAllData = ()  => ({
    type: actionTypes.LOAD_ALL_DATA_REQUEST
})


/**
 * action prototype
 * {
 *      type: <ActionType>
 *      meta: <Object>
 *      payload: <Object>
 * }
 */

//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
//                     HPI                      //
//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
//#region hpi

export const programFetchRequest = () => ({
    type: actionTypes.PROGRAM_FETCH_REQUEST
})

export const programUpdateRequest = (beforeUpdate = false) => ({
    type: actionTypes.PROGRAM_UPDATE_REQUEST,
    payload: {
        beforeUpdate: beforeUpdate
    }
});

// export const programFilterRequest = () => ({
//     type: actionTypes.PROGRAM_FILTER_REQUEST,
// })

//#endregion hpi


//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
//                   programData                //
//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
//#region programData

export const moviesUpdateItem = (pk, dataMovie, dataAttributes, dataMeta, updateLocal = false) => ({
    type: actionTypes.MOVIES_UPDATE_ITEM_REQUEST,
    meta: {},
    payload: {
        pk: pk,
        dataMovie: dataMovie,
        dataAttributes: dataAttributes,
        dataMeta: dataMeta,
        updateLocal: updateLocal
    }
})

export const moviesUpdateOrderRequest = (oldIndex, newIndex) => ({
    type: actionTypes.MOVIES_UPDATE_ORDER_REQUEST,
    meta: {},
    payload: {
        oldIndex: oldIndex,
        newIndex: newIndex
    }
})

export const movieExtensionsUpdateItem = (pk, extension, value) => ({
    type: actionTypes.MOVIE_EXTENSIONS_UPDATE_ITEM,
    meta: {},
    payload: {
        pk: pk,
        extension: extension,
        value: value
    }
})

export const movieExtensionsAddItemToReset = (pk) => ({
    type: actionTypes.MOVIE_EXTENSIONS_ADD_ITEM_TO_RESET,
    meta: {},
    payload: {
        pk: pk
    }
})

export const reorderProgramItem = () =>({
    type: actionTypes.PROGRAM_ITEM_REORDER_REQUEST
})

export const selectionsDisplayAddItem = (values) => ({
    type: actionTypes.ITEMSELECTIONSDISPLAY_REQUEST_ADD_ITEM,
    meta: {},
    payload: {
        values: values
    }
})

export const selectionsDisplayDeleteItem = pk => ({
    type: actionTypes.ITEMSELECTIONSDISPLAY_REQUEST_DELETE_ITEM,
    meta: {},
    payload: {
        pk: pk
    }
})

export const selectionsDisplayUpdateOrderRequest= (oldIndex, newIndex) => ({
    type: actionTypes.ITEMSELECTIONSDISPLAY_REQUEST_UPDATE_ORDER,
    meta: {},
    payload: {
        oldIndex: oldIndex,
        newIndex: newIndex
    }
})

// export const selectionsAddItem = (title, filterType, filterValue, expireDate) => ({
//     type: actionTypes.ITEMSELECTIONS_ADD_ITEM,
//     meta: {},
//     payload: {
//         title: title,
//         filterType: filterType, 
//         filterValue: filterValue, 
//         expireDate: expireDate
//     }
// })

// export const selectionsDeleteItem = (id) => ({
//     type: actionTypes.ITEMSELECTIONS_DELETE_ITEM,
//     meta: {},
//     payload: {
//         id: id
//     }
// })

export const selectionUpdateItemSettings = (pk, title, style, trailerAutoplay, cinemasFilter) => ({
    type: actionTypes.ITEMSELECTIONS_UPDATE_ITEM_SETTINGS,
    payload: {
        pk: pk,
        title: title,
        style: style,
        trailerAutoplay: trailerAutoplay,
        cinemasFilter: cinemasFilter
    }
})

export const selectionsUpdateItemShowInApp = (pk, bool) => ({
    type: actionTypes.ITEMSELECTIONS_UPDATE_ITEM_SHOWINAPP,
    meta: {},
    payload: {
        pk: pk,
        showInApp: bool
    }
})

// export const collectionDeleteItem = (id) => ({
//     type: actionTypes.ITEMCOLLECTIONS_DELETE_ITEM,
//     meta: {},
//     payload: {
//         id: id
//     }
// })

export const collectionUpdateItemItems = (pk, items) => ({
    type: actionTypes.ITEMCOLLECTIONS_UPDATE_ITEM_ITEMS,
    meta: {},
    payload: {
        pk: pk,
        items: items
    }
})

export const collectionUpdateItemEditedTrue = pk => ({
    type: actionTypes.ITEMCOLLECTIONS_UPDATE_ITEM_EDITED_TRUE,
    meta: {},
    payload: {
        pk: pk
    }
})

export const collectionUpdateItemEditedFalse = pk => ({
    type: actionTypes.ITEMCOLLECTIONS_UPDATE_ITEM_EDITED_FALSE,
    meta: {},
    payload: {
        pk: pk
    }
})

export const highlightsAddItem = (itemData, closePagePath = false) => ({
    type: actionTypes.HIGHLIGHTS_REQUEST_ADD_ITEM,
    meta: {},
    payload: {
        itemData: itemData,
        closePagePath: closePagePath
    }
})

export const highlightsUpdateItem = (pk, itemData) => ({
    type: actionTypes.HIGHLIGHTS_UPDATE_ITEM,
    meta: {},
    payload: {
        pk: pk,
        itemData: itemData
    }
})

export const highlightsDeleteItem = pk => ({
    type: actionTypes.HIGHLIGHTS_DELETE_ITEM,
    meta: {},
    payload: {
        pk: pk
    }
})


export const adsAddItem = (itemData, closePagePath = false) => ({
    type: actionTypes.ADS_REQUEST_ADD_ITEM,
    meta: {},
    payload: {
        itemData: itemData,
        closePagePath: closePagePath
    }
})

export const adsUpdateItem = (pk, itemData) => ({
    type: actionTypes.ADS_UPDATE_ITEM,
    meta: {},
    payload: {
        pk: pk,
        itemData: itemData
    }
})

export const adsDeleteItem = pk => ({
    type: actionTypes.ADS_DELETE_ITEM,
    meta: {},
    payload: {
        pk: pk
    }
})

export const advertisementsAddItem = (itemData, closePagePath = false) => ({
    type: actionTypes.ADVERTISEMENTS_REQUEST_ADD_ITEM,
    meta: {},
    payload: {
        itemData: itemData,
        closePagePath: closePagePath
    }
})


export const advertisementsUpdateItem =  (pk, itemData) => ({
    type: actionTypes.ADVERTISEMENTS_UPDATE_ITEM,
    meta: {},
    payload: {
        pk: pk,
        itemData: itemData
    }
})

export const advertisementsDeleteItem =  pk => ({
    type: actionTypes.ADVERTSIEMENTS_REQUEST_DELETE_ITEM,
    meta: {},
    payload: {
        pk: pk
    }
})


export const weischerAdAddItem = (itemData) => ({
    type: actionTypes.WEISCHERAD_REQUEST_ADD_ITEM,
    meta: {},
    payload: {
        itemData: itemData
    }
})

export const weischerAdUpdateItem = (pk, itemData) => ({
    type: actionTypes.WEISCHERAD_UPDATE_ITEM,
    meta: {},
    payload: {
        pk: pk,
        itemData: itemData
    }
})

export const weischerAdDeleteItem = pk => ({
    type: actionTypes.WEISCHERAD_DELETE_ITEM,
    meta: {},
    payload: {
        pk: pk
    }
})


// #endregion programData

//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
//                  WP-Server-Data              //
//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//

export const wpDataUpdateRequest = () => ({
    type: actionTypes.WP_DATA_UPDATE_REQUEST,
})

//#endregion wpServerData

//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
//                  WP-Local-Data               //
//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
//#region wpLocalData

export const updateWPLocalDataFrontByKey = (key, value) => ({
    type: actionTypes.WP_LOCAL_DATA_FRONT_UPDATE_BY_KEY,
    payload: {
        key: key,
        value: value
    }
})

//#endregion wpLocalData


//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
//                Signage-Data                  //
//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
export const signageRequestCreateScreen = (screenData) => ({
    type: actionTypes.SIGNAGE_SCREEN_CREATE_REQUEST,
    payload: {
        screenData: screenData
    }
})

export const signageRequestUpdateScreen = (pk, itemCollections, newItemCollections, updatedItemCollections, deletedItemCollections, screenData) => ({
    type: actionTypes.SIGNAGE_SCREEN_UPDATE_REQUEST,
    payload: {
        pk: pk, 
        itemCollections: itemCollections, 
        newItemCollections: newItemCollections, 
        updatedItemCollections: updatedItemCollections, 
        deletedItemCollections: deletedItemCollections,
        screenData: screenData
    }
})

//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
//           Multisite-Selector-Data            //
//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
export const multisiteSelectorGetRequest = (overlay = true, signal = false) => ({
    type: actionTypes.MULTISITE_SELECTOR_GET_REQUEST,
    meta: {},
    payload: {
        overlay: overlay,
        signal: signal
    }
})

export const multisiteSeletorUpdateRequest = () => ({
    type: actionTypes.MULTISITE_SELECTOR_UPDATE_REQUEST,
    meta: {},
    payload: {
        overlay: true,
    }
})

export const multisiteSelectorOrderUpdate= (oldIndex, newIndex) => ({
    type: actionTypes.MULTISITE_SELECTOR_ORDER_UPDATE,
    meta: {},
    payload: {
        oldIndex: oldIndex,
        newIndex: newIndex
    }
})


export const multisiteSelectorAddCustomItem = (title, url, cinemaPk) => ({
    type: actionTypes.MULTISITE_SELECTOR_ITEM_ADD_CUSTOM_OBJ,
    meta: {},
    payload: {
        title: title, 
        url: url, 
        cinemaPk: cinemaPk
    }
})

export const multisiteSelectorAddCinemaItem = (cinemaPk) => ({
    type: actionTypes.MULTISITE_SELECTOR_ITEM_ADD_CINEMA_OBJ,
    meta: {},
    payload: {
        cinemaPk: cinemaPk
    }
})

export const multisiteSelectorItemRemove = (pk) => ({
    type: actionTypes.MULTISITE_SELECTOR_ITEM_REMOVE,
    meta: {},
    payload: {
        pk: pk
    }
})



//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
//                Print-Data                    //
//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
//#region printServerData
export const printDataUpdateRequest = () => ({
    type: actionTypes.PRINT_DATA_UPDATE_REQUEST,
    meta: {},
    payload: {}
})

export const printDataPdfRequest = (printFormatState, printFormat, landscape, activeWeek, printType, cinemaId) => ({
    type: actionTypes.PRINT_DATA_FLYER_PDF_REQUEST,
    meta: {},
    payload: {
        printFormatState: printFormatState, 
        printFormat: printFormat, 
        landscape: landscape, 
        activeWeek: activeWeek, 
        printType: printType,
        cinemaId: cinemaId
    }
})

export const printDataPdfReset = () => ({
    type: actionTypes.PRINT_DATA_FLYER_PDF_RESET,
    meta: {},
    payload: {}
})

export const printDataWeekProgramPdfRequest = (printFormatState, printFormat, landscape, activeWeek, printType, cinemaId) => ({
    type: actionTypes.PRINT_DATA_WEEKPROGRAMFLYER_PDF_REQUEST,
    meta: {},
    payload: {
        printFormatState: printFormatState, 
        printFormat: printFormat, 
        landscape: landscape, 
        activeWeek: activeWeek, 
        printType: printType,
        cinemaId: cinemaId
    }
})

export const printDataWeekProgramPdfReset = () => ({
    type: actionTypes.PRINT_DATA_WEEKPROGRAMFLYER_PDF_RESET,
    meta: {},
    payload: {}
})


//#endregion printServerData^dt
//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
//                Push-Data                    //
//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
//#region pushServerData
export const pushCreateAttachedItemUpdate = (itemData) => ({
    type: actionTypes.PUSH_CREATE_ATTACHED_ITEM_UPDATE,
    meta: {},
    payload: {
        itemData: itemData
    }
})

export const pushCreateFormUpdate = (itemData) => ({
    type: actionTypes.PUSH_CREATE_FORM_UPDATE,
    meta: {},
    payload: {
        itemData: itemData
    }
})

export const pushCreateRequest = () => ({
    type: actionTypes.PUSH_CREATE_REQUEST,
    meta: {},
    payload: {}
})




//#endregion prushServerData
//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
//                      UI                      //
//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
//#region uiData
export const setEditSliderName = (value) => ({
    type: actionTypes.PROGRAM_SET_EDIT_SLIDER_NAME,
    meta: {},
    payload: {
        value: value
    }
})

export const setActiveSelection = (activeSelectionID) => ({
    type: actionTypes.SETTINGS_SET_ACTIVE_SELECTION,
    meta: {},
    payload: {
        activeSelectionID: activeSelectionID
    }
})

export const setActiveMenuItem = (activeMenuItemID) => ({
    type: actionTypes.SETTINGS_SET_ACTIVE_MENUITEM,
    meta: {},
    payload: {
        activeMenuItemID: activeMenuItemID
    }
})

export const setActiveTab = (activeTabID) => ({
    type: actionTypes.PROGRAM_SET_ACTIVE_TAB,
    meta: {},
    payload: {
        activeTabID: activeTabID
    }
})

export const printSetActiveTab = (activeTabID) => ({
    type: actionTypes.PRINT_SET_ACTIVE_TAB,
    meta: {},
    payload: {
        activeTabID: activeTabID
    }
})

export const programSetActiveSelection = (activeSelectionID) => ({
    type: actionTypes.PROGRAM_SET_ACTIVE_SELECTION,
    meta: {},
    payload: {
        activeSelectionID: activeSelectionID
    }
})

export const programDropzonesShow = () => ({
    type: actionTypes.UI_PROGRAM_ACTIVE_DROPZONES_SET_TRUE,
    meta: {},
    payload: {}
})

export const programDropzonesHide = () => ({
    type: actionTypes.UI_PROGRAM_ACTIVE_DROPZONES_SET_FALSE,
    meta: {},
    payload: {}
})

export const dashboardSetActiveUpdateText = (activeUpdateTextID) => ({
    type: actionTypes.DASHBOARD_SET_ACTIVE_UPDATETEXT,
    meta: {},
    payload: {
        activeUpdateTextID: activeUpdateTextID
    }
})

export const dashboardSetDisplayUpdateHistory = (displayUpdateHistory) => ({
    type: actionTypes.DASHBOARD_SET_DISPLAY_UPDATEHISTORY,
    meta: {},
    payload: {
        displayUpdateHistory: displayUpdateHistory
    }
})

export const uiSetRequestOverlayType = overlayType => ({
    type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_SET_OVERLAY_TYPE,
    meta: {},
    payload: {
        overlayType: overlayType
    }
})

export const uiSetRequestOverlayRequest = requestType => ({
    type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_SET_REQUEST_TYPE,
    meta: {},
    payload: {
        requestType: requestType
    }
})

export const uiProgramSetEditSelection = (selectionId, selectionType) => ({
    type: actionTypes.UI_PROGRAM_SET_EDIT_SELECTION,
    meta: {},
    payload: {
        selectionId: selectionId,
        selectionType: selectionType
    }
})

export const uiRequestOverlayReset = () => ({
    type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_RESET
})


export const uiOverlayReset = (overlayKey) => ({
    type: actionTypes.OVERLAY_SET_RESET,
    payload: {
        overlayKey: overlayKey
    }
})






    

// export const generalSetButtonType = buttonType => ({
//     type: actionTypes.GENERAL_SET_BUTTON_TYPE,
//     meta: {},
//     payload: {
//         buttonType: buttonType
//     }
// }) 
    

//#endregion uiData

//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
//                  PrintData                   //
//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
//#region printData





export const onPrintTypesPdfRequest = (printFormatState, printFormat, landscape, activeWeek, printType, cinemaId) => ({
    type: actionTypes.PRINT_DATA_PRINT_TYPES_PDF_REQUEST,
    meta: {},
    payload: {
        printFormatState: printFormatState,
        printFormat: printFormat,
        landscape: landscape,
        activeWeek: activeWeek,
        printType: printType,
        cinemaId: cinemaId
    }
})

export const onPrintTypesPdfResetState = () => ({
    type: actionTypes.PRINT_DATA_PRINT_TYPES_PDF_RESET_STATE,
    meta: {},
    payload: {}
})

export const postPosterPdfCombinedSuccess = ( data ) => ({
    type: actionTypes.POST_POSTER_PDF_COMBINED_SUCCESS,
    meta: {},
    payload: {
        data: data
    }
})


export const postPosterPdfCombinedError = (errorMessage = null ) => ({
    type: actionTypes.POST_POSTER_PDF_COMBINED_ERROR,
    meta: {},
    payload: {
        errorMessage: errorMessage
    }
})

export const printToolAddItem = (printType, printFormat, landscape, itemId)  => ({
    type: actionTypes.PRINT_TOOL_ADD_ITEM,
    payload: {
        printType: printType,
        printFormat: printFormat,
        landscape: landscape,
        itemId: itemId
    }
})

export const printToolReorderItem = (printType, printFormat, landscape, oldIndex, newIndex)  => ({
    type: actionTypes.PRINT_TOOL_REORDER_ITEM,
    payload: {
        printType: printType,
        printFormat: printFormat,
        landscape: landscape,
        oldIndex: oldIndex,
        newIndex: newIndex
    }
})

export const printToolDeleteItem = (printType, printFormat, landscape, itemId)  => ({
    type: actionTypes.PRINT_TOOL_DELETE_ITEM,
    payload: {
        printType: printType,
        printFormat: printFormat,
        landscape: landscape,
        itemId: itemId
    }
})

export const printToolSetWeek = (week) => ({
    type: actionTypes.PRINT_TOOL_SET_WEEK,
    meta: {},
    payload: {
        week: week
    }
})

export const printToolChooseCinema = (cinemaId, path) => ({
    type: actionTypes.PRINT_TOOL_CHOOSE_CINEMA,
    payload: {
        cinemaId: cinemaId,
        path: path
    }
})


export const chooseAndDeleteAllPrintItems = (printType, printFormat, items) => ({
    type: actionTypes.CHOOSE_AND_DELETE_ITEMS,
    meta: {},
    payload: {
        printType: printType,
        printFormat: printFormat,
        items: items
    }
})

export const addFlyerStructureItem = (section, side, area, itemId, itemType) => ({
    type: actionTypes.PRINT_LOCAL_DATA_FLYER_ADD_FLYER_STRUCTURE_ITEM,
    meta: {},
    payload: {
        section: section,
        side: side,
        area: area,
        itemId: itemId,
        itemType: itemType,
        edited: true
    }
})

export const deleteFlyerStructureItem = (section, side, area, itemId, movieId = false, itemType) => ({
    type: actionTypes.PRINT_LOCAL_DATA_FLYER_DELETE_FLYER_STRUCTURE_ITEM,
    meta: {},
    payload: {
        section: section,
        side: side,
        area: area,
        itemId: itemId,
        movieId: movieId,
        itemType: itemType
    }
})

export const updateFlyerTooHigh = (side, section, tooHigh) => ({
    type: actionTypes.PRINT_DATA_FLYER_UPDATE_TOO_HIGH,
    meta: {},
    payload: {
        side: side,
        section: section,
        tooHigh: tooHigh
    }
})

export const addFlyerElement = (section, item) => ({
    type: actionTypes.PRINT_LOCAL_DATA_FLYER_ADD_FLYER_ELEMENT,
    meta: {},
    payload: {
        section: section,
        item: item,
    }
})

export const updateFlyerSettings = (payload) => ({
    type: actionTypes.PRINT_LOCAL_DATA_FLYER_UPDATE_FLYER_SETTINGS,
    meta: {},
    payload: {
        payload: payload,
    }
})

export const updateFlyerOrder = ( side, section, area, order) => ({
    type: actionTypes.PRINT_LOCAL_DATA_FLYER_UPDATE_FLYER_ORDER,
    meta: {},
    payload: {
        side: side,
        section: section,
        area: area,
        order: order,
    }
})

export const updateFlyerElement = (section, item) => ({
    type: actionTypes.PRINT_LOCAL_DATA_FLYER_UPDATE_FLYER_ELEMENT,
    meta: {},
    payload: {
        section: section,
        item: item,
    }
})

export const deleteFlyerElement = (section, itemId) => ({
    type: actionTypes.PRINT_LOCAL_DATA_FLYER_DELETE_FLYER_ELEMENT,
    meta: {},
    payload: {
        section: section,
        itemId: itemId,
    }
})

export const deleteFlyerCustomElement = (id, type)  => ({
    type: actionTypes.PRINT_LOCAL_DATA_FLYER_DELETE_FLYER_CUSTOM_ELEMENT,
    payload: {
        id: id,
        type: type
    }
})

export const setFlyerCurrentWeek = week => ({
    type: actionTypes.PRINT_LOCAL_DATA_FLYER_UPDATE_CURRENT_WEEK,
    meta: {},
    payload: {
        week: week
    }
})

export const setWeekProgramFlyerCurrentWeek = week => ({
    type: actionTypes.PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_UPDATE_CURRENT_WEEK,
    meta: {},
    payload: {
        week: week
    }
})

export const addWeekProgramFlyerDate = (item) => ({
    type: actionTypes.PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_ADD_DATE_SETTINGS,
    meta: {},
    payload: {
        item: item
    }
})

export const updateWeekProgramFlyerDate = (item) => ({
    type: actionTypes.PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_UPDATE_DATE_SETTINGS,
    meta: {},
    payload: {
        item: item
    }
})

export const deleteWeekProgramFlyerDate = (itemId) => ({
    type: actionTypes.PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_DELETE_DATE_SETTINGS,
    meta: {},
    payload: {
        itemId: itemId
    }
})

export const deleteAllWeekProgramFlyerDate = () => ({
    type: actionTypes.PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_DELETE_ALL_DATE_SETTINGS,
    meta: {},
    payload: {}
})


export const updateWeekProgramFlyerSettings = (payload) => ({
    type: actionTypes.PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_UPDATE_WEEKPROGRAMFLYER_SETTINGS,
    meta: {},
    payload: {
        payload: payload,
    }
})


export const setWeekProgramFlyerCustomPeriodActive = (active) => ({
    type: actionTypes.PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_SET_CUSTOM_PERIOD_ACTIVE,
    meta: {},
    payload: {
        active: active,
    }
})

export const updateWeekProgramFlyerOrder = (order, type) => ({
    type: actionTypes.PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_UPDATE_WEEKPROGRAMFLYER_ORDER,
    meta: {},
    payload: {
        order: order,
        type: type
    }
})

export const bulkAddWeekProgramFlyerMovie = (items, order) => ({
    type: actionTypes.PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_BULK_ADD_WEEKPROGRAMFLYER_ELEMENT,
    meta: {},
    payload: {
        items: items,
        order: order,
        edited: true
    }
})

export const addWeekProgramFlyerMovie = (item) => ({
    type: actionTypes.PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_ADD_WEEKPROGRAMFLYER_ELEMENT,
    meta: {},
    payload: {
        item: item,
        edited: true
    }
})

export const deleteWeekProgramFlyerMovie = (itemId) => ({
    type: actionTypes.PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_DELETE_WEEKPROGRAMFLYER_ELEMENT,
    meta: {},
    payload: {
        itemId: itemId
    }
})


//#endregion printData


//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
//                 Newsletter                   //
//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
//#region newsletterData


export const newsletterAddNewsletterItem = (campaignId, listId, itemId) => ({
    type: actionTypes.NEWSLETTER_ADD_NEWSLETTER_ITEM,
    payload: {
        campaignId: campaignId,
        listId: listId,
        itemId: itemId,
    }
})

export const newsletterDeleteNewsletterItem = (campaignId, listId, itemId) => ({
    type: actionTypes.NEWSLETTER_DELETE_NEWSLETTER_ITEM,
    payload: {
        campaignId: campaignId,
        listId: listId,
        itemId: itemId,
    }
})

export const newsletterReorderNewsletterItem = (campaignId, listId, oldIndex, newIndex) => ({
    type: actionTypes.NEWSLETTER_REORDER_NEWSLETTER_ITEM,
    payload: {
        campaignId: campaignId,
        listId: listId,
        oldIndex: oldIndex,
        newIndex: newIndex
    }
})

export const newsletterUpdateNewsletterCurrentWeek = (campaignId, currentWeek) => ({
    type: actionTypes.NEWSLETTER_UPDATE_NEWSLETTER_CURRENT_WEEK,
    meta: {},
    payload: {
        campaignId: campaignId,
        currentWeek: currentWeek,
    }
})

export const newsletterUpdateCampaignRequest = (campaignId, data) => ({
    type: actionTypes.NEWSLETTER_UPDATE_CAMPAIGN_REQUEST,
    payload: {
        campaignId: campaignId,
        data: data
    }
})

export const newsletterCreateItem =  (itemType, itemData) => ({
    type: actionTypes.NEWSLETTER_CREATE_ITEM,
    payload: {
        itemType: itemType,
        itemData: itemData
    }
})

export const newsletterUpdateElement = (itemType, itemData) => ({
    type: actionTypes.NEWSLETTER_UPDATE_ITEM,
    payload: {
        itemType: itemType,
        itemData: itemData
    }
})

export const newsletterDeleteElement = (itemType, itemId) => ({
    type: actionTypes.NEWSLETTER_DELETE_ITEM,
    payload: {
        itemType: itemType,
        itemId: itemId
    }
})

export const newsletterUpdateRequest = ()  => ({
    type: actionTypes.NEWSLETTER_UPDATE_REQUEST,
    payload: {}
})

export const newsletterSendRequest = (campaignId, items) => ({
    type: actionTypes.NEWSLETTER_SEND_REQUEST,
    payload: {
        campaignId: campaignId,
        items: items,
    }
})

export const newsletterCancelRequest = () => ({
    type: actionTypes.NEWSLETTER_CANCEL_REQUEST
})


//#endregion newsletterData





//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
//               EVENTS                         //
//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//

export const fetchEventsRequest = (signal = false) => ({
    type: actionTypes.EVENTS_ALL_REQUEST,
    payload: {
        signal: signal
    }
})

export const eventUpdateRequest = (id, data) => ({
    type: actionTypes.EVENTS_EVENTS_UPDATE_REQUEST,
    payload: {
        id: id,
        data: data
    }
})

export const eventSendMailRequest = (id) => ({
    type: actionTypes.EVENTS_EVENTS_SEND_MAIL_REQUEST,
    payload: {
        id: id
    }
})

export const eventDeleteRequest = id => ({
    type: actionTypes.EVENTS_EVENTS_DELETE_REQUEST,
    payload: {
        id: id
    }
})

